export const fritzschoff = {
  firebase: {
    apiKey: "AIzaSyDRiBbQmzMGxa90TiaPyf1Q5Avy5kikgWM",
    authDomain: "fritzschoff-10247.firebaseapp.com",
    databaseURL: "https://fritzschoff-10247.firebaseio.com",
    projectId: "fritzschoff-10247",
    storageBucket: "fritzschoff-10247.appspot.com",
    messagingSenderId: "986427137045",
    appId: "1:986427137045:web:21f09bedff6aca2cc2821c"
  },
  emailAPI: {
    tonteppich: {
      contact: 'test@test.de'
    }
  },
  passwords: {
    tonteppich: {
      import: 'kickers'
    }
  },
  infura: {
    id: '123123123123123123',
    url: (network: 'mainnet' | 'kovan' | 'rinkeby' = 'mainnet') => `https://${network}.infura.io/v3/12312313123123123`
  }
}
